export enum TeamJoinType {
  selfJoin = 'SELF_JOIN',
  invitation = 'INVITATION',
}

export enum TeamMemberPendingRequestStatus {
  SENT = 'SENT',
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  UNKNOWN = 'UNKNOWN',
}

export enum TeamType {
  organizationMembers = 'ORGANIZATION_MEMBERS',
  organization = 'ORGANIZATION_TEAM',
  developer = 'DEVELOPER_TEAM',
}

export enum FriendlyUserRole {
  DEVELOPER_TEAM_ADMIN = 'Admin',
  DEVELOPER = 'Developer',
}

export enum AppType {
  web = 'web',
  mobile = 'mobile',
  backend = 'backend',
}

export enum AppStatusCommand {
  SUBMIT_FOR_TECH_REVIEW = 'SUBMIT_FOR_TECH_REVIEW',
  DECLINE_TECH_REVIEW = 'DECLINE_TECH_REVIEW',
  WITHDRAW_FROM_TECH_REVIEW = 'WITHDRAW_FROM_TECH_REVIEW',
  APPROVE_TECH_REVIEW = 'APPROVE_TECH_REVIEW',
  SUBMIT_FOR_INTERNAL_PUBLISH_REVIEW = 'SUBMIT_FOR_INTERNAL_PUBLISH_REVIEW',
  SUBMIT_FOR_MARKETPLACE_PUBLISH_REVIEW = 'SUBMIT_FOR_MARKETPLACE_PUBLISH_REVIEW',
  APPROVE_INTERNAL_PUBLISH = 'APPROVE_INTERNAL_PUBLISH',
  APPROVE_MARKETPLACE_PUBLISH = 'APPROVE_MARKETPLACE_PUBLISH',
  DEPRECIATE = 'DEPRECIATE',
}

export enum AppStatus {
  DEVELOPMENT = 'DEVELOPMENT',
  IN_REVIEW = 'IN-REVIEW',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  LIVE = 'LIVE',
  DEPRECATED = 'DEPRECATED',
}

export enum RequiredState {
  organization = 'organization',
  orgTenantAndTeam = 'orgTenantAndTeam',
}

export enum HostingLocation {
  PLATFORM = 'PLATFORM',
  EXTERNAL = 'EXTERNAL',
}

export enum LinkType {
  USER_GUIDE_URL = 'userGuideUrl',
  SERVER_URL = 'serverUrl',
  UI_HOME_URL = 'uiHomeUrl',
}
